// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"a4b41b96","575":"9f2a9a1a","744":"dab6f93b","801":"c033d138","905":"f6c3e6cb","981":"9bb0eee8"}[chunkId] + ".chunk.js";
};